import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "events-page" }
const _hoisted_2 = { class: "log-wrapper" }
const _hoisted_3 = { class: "scroll-container" }
const _hoisted_4 = { class: "event-line" }
const _hoisted_5 = { class: "event-line" }
const _hoisted_6 = { class: "event-line" }
const _hoisted_7 = { class: "event-line" }
const _hoisted_8 = { class: "event-line" }
const _hoisted_9 = { class: "event-line" }

import { onMounted, computed } from "vue";
import { useFiStore } from "../stores/buildStores";
import TopPanel from "../components/topPanel.vue";

interface UserAction {
  action: string;
  user_id: string;
  build_id: string;
  fi_number: string;
  config_id: string;
  metadata: string;
  timestamp: string;
}

// const typedActions = computed(() => actions.value as UserAction[]) // in order

export default /*@__PURE__*/_defineComponent({
  __name: 'EventHistory',
  setup(__props) {

const fiStore = useFiStore();
const actions = computed(() => fiStore.actions);

const typedActions = computed(
  () => [...actions.value].reverse() as UserAction[]
); // reverse order

onMounted(() => {
  fiStore.loadUserActions(); // ✅ correct
});

function formatTimestamp(ts) {
  return new Date(ts).toLocaleString();
}

return (_ctx: any,_cache: any) => {
  const _component_q2_option = _resolveComponent("q2-option")!
  const _component_q2_optgroup = _resolveComponent("q2-optgroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopPanel),
    _createVNode(_TransitionGroup, {
      name: "fade-slide",
      tag: "div",
      class: "event-list"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "log-heading" }, "User Event Log", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_q2_optgroup, { label: "User Actions" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typedActions.value, (action, index) => {
                  return (_openBlock(), _createBlock(_component_q2_option, {
                    key: index,
                    value: index,
                    class: "event-entry"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[0] || (_cache[0] = _createTextVNode(" 🛠️ ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(action.action), 1)
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _cache[1] || (_cache[1] = _createTextVNode(" 👤 ", -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("strong", null, "User:", -1)),
                        _createTextVNode(" " + _toDisplayString(action.user_id), 1)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _cache[3] || (_cache[3] = _createTextVNode(" 🏦 ", -1)),
                        _cache[4] || (_cache[4] = _createElementVNode("strong", null, "FI:", -1)),
                        _createTextVNode(" " + _toDisplayString(action.fi_number) + "   🧩 ", 1),
                        _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Config:", -1)),
                        _createTextVNode(" " + _toDisplayString(action.config_id), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _cache[6] || (_cache[6] = _createTextVNode(" 🏗️ ", -1)),
                        _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Build:", -1)),
                        _createTextVNode(" " + _toDisplayString(action.build_id), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _cache[8] || (_cache[8] = _createTextVNode(" 📝 ", -1)),
                        _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Metadata:", -1)),
                        _createTextVNode(" " + _toDisplayString(action.metadata), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _cache[10] || (_cache[10] = _createTextVNode(" 🕒 ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(formatTimestamp(action.timestamp)), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})